export enum PurchaseApprovalStatus {
  PENDING_REVIEW = "PENDING_REVIEW",
  VALIDATED = "VALIDATED",
  ERROR = "ERROR",
}